import { render, staticRenderFns } from "./SelectedStoreWithdrawalsAdmin.vue?vue&type=template&id=0ddd2956&scoped=true&lang=pug"
import script from "./SelectedStoreWithdrawalsAdmin.vue?vue&type=script&lang=js"
export * from "./SelectedStoreWithdrawalsAdmin.vue?vue&type=script&lang=js"
import style0 from "./SelectedStoreWithdrawalsAdmin.vue?vue&type=style&index=0&id=0ddd2956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd2956",
  null
  
)

export default component.exports